// import React, { useState, useRef, useEffect } from "react";

import ListItemRelocates from "../../../../components/@documents/item_relocates/ListItemRelocates";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemRelocatesPage() {

    return (
        <ListItemRelocates 
            routeType={routeTypes.admin}
        />
    )
}